import { WalletCardDownloadProps } from './WalletCardDownload.types'

export const useWalletCardDownload = ({
  patientId,
  surgeryId,
  webToken,
  inviteToken,
}: WalletCardDownloadProps) => {
  const WALLET_API_URL = process.env.REACT_APP_WALLET_API_URL?.replace(
    /\/$/,
    ''
  )

  const appleWalletUrl = `${WALLET_API_URL}/surgery_passes/${patientId}/${surgeryId}/apple?inviteToken=${inviteToken}`
  const webWalletUrl = webToken
    ? `${WALLET_API_URL}/surgery_passes/${patientId}/${surgeryId}/web?token=${webToken}`
    : undefined

  return {
    appleWalletUrl,
    webWalletUrl,
  }
}
